module.exports = __webpack_public_path__ + "assets/img/ad2.186f4966.svg";